import React, { Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import Layout from "components/Common/Layout";
import { ROUTER_PATH } from "config/path";
import AuthSignInPage from "pages/auth/signIn";
import AuthSignUpPage from "pages/auth/signUp";
import AuthFindPasswordPage from "pages/auth/findpassword";
import DocumentArchiveCreatePage from "pages/document/archives/create";
import DocumentArchivesDashboardPage from "pages/document/archives/dashboard";
import AnalysisSelectFormPage from "pages/document/analysis/create";
import DocumentAnalysisDetailPage from "pages/document/analysis/detail";
import DocumentAnalysisDashboardPage from "pages/document/analysis/dashboard";
import DocumentWorkCreatePage from "pages/document/work/create";
import DocumentWorkDashboardPage from "pages/document/work/dashboard";
import DocumentWorkDetailPage from "pages/document/work/detail";
import MypageInformationPage from "pages/mypage/infomation";
import MypagePaymentPage from "pages/mypage/payment";
import TagCreatePage from "pages/tag/create";
import TagDashboardPage from "pages/tag/dashboard";
import UserDashboardPage from "pages/user/dashboard";
import UserDetailPage from "pages/user/dashboard/detail";
import TagDetailPage from "pages/tag/dashboard/detail";
import TagDetailEditPage from "pages/tag/dashboard/detail/edit";
import Dashboard from "pages/dashboard";
import MyPageDeskPage from "pages/mypage/desk";
import Loading from "components/Common/Loading/Loading";
import ProtectedRoute from "components/auth/ProtectedRoute";
import NoticeDashboardPage from "pages/notice/dashboard";
import NoticeDashboardDetailPage from "pages/notice/dashboard/detail";
import NoticeCreatePage from "pages/notice/create";
import NoticeDashboardEditPage from "pages/notice/dashboard/detail/edit";
import { AUTHORITY_TYPES } from "config/constant";
import DocumentAnalysisFormPage from "pages/document/analysis/create";
import Policy from "./pages/policy/Policy";
import PushNotificationPage from "pages/pushNotification";
import PdfPreviewPage from "pages/pdfPreview";

const Page404 = React.lazy(() => import("./pages/page404/Page404"));

const routes = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<Loading />}>
        <Layout>
          <Outlet />
        </Layout>
      </Suspense>
    ),
    children: [
      // dashboard
      {
        path: ROUTER_PATH.home,
        element: (
          <ProtectedRoute
            redirectTo={ROUTER_PATH.document.archive.dashboard}
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <Dashboard />
          </ProtectedRoute>
        ),
      },

      //document.work
      {
        path: ROUTER_PATH.document.work.create._path,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <DocumentWorkCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.document.work.create.form(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <DocumentWorkCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.document.work.dashboard,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <DocumentWorkDashboardPage />
          </ProtectedRoute>
        ),
        handle: {
          title: "WORK",
        },
      },
      {
        path: ROUTER_PATH.document.work.detail(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <DocumentWorkDetailPage />
          </ProtectedRoute>
        ),
      },

      //document.analysis
      {
        path: ROUTER_PATH.document.analysis.create._path,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <AnalysisSelectFormPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.document.analysis.create.form(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <DocumentAnalysisFormPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.document.analysis.dashboard,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <DocumentAnalysisDashboardPage />
          </ProtectedRoute>
        ),
        handle: {
          title: "ANALYSIS",
        },
      },
      {
        path: ROUTER_PATH.document.analysis.detail(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <DocumentAnalysisDetailPage />
          </ProtectedRoute>
        ),
      },

      //document.archives
      {
        path: ROUTER_PATH.document.archive.create._path,
        element: (
          <ProtectedRoute>
            <DocumentArchiveCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.document.archive.create.form(),
        element: (
          <ProtectedRoute>
            <DocumentArchiveCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.document.archive.dashboard,
        element: (
          <ProtectedRoute>
            <DocumentArchivesDashboardPage />
          </ProtectedRoute>
        ),
        handle: {
          title: "ARCHIVES",
        },
      },

      //mypage
      {
        path: ROUTER_PATH.myPage.information,
        element: (
          <ProtectedRoute>
            <MypageInformationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.myPage.payment,
        element: (
          <ProtectedRoute>
            <MypagePaymentPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.myPage.desk,
        element: (
          <ProtectedRoute>
            <MyPageDeskPage />
          </ProtectedRoute>
        ),
        handle: {
          title: "MY DESK",
        },
      },

      //tag
      {
        path: ROUTER_PATH.tag.create,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <TagCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.tag.dashboard._path,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <TagDashboardPage />
          </ProtectedRoute>
        ),
        handle: {
          title: "TAG MANAGEMENT",
        },
      },
      {
        path: ROUTER_PATH.tag.dashboard.detail._path(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <TagDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.tag.dashboard.detail.edit(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <TagDetailEditPage />
          </ProtectedRoute>
        ),
      },

      //user
      {
        path: ROUTER_PATH.user.dashboard._path,
        element: (
          <ProtectedRoute forAdmin>
            <UserDashboardPage />
          </ProtectedRoute>
        ),
        handle: {
          title: "USER MANAGEMENT",
        },
      },
      {
        path: ROUTER_PATH.user.dashboard.detail(),
        element: (
          <ProtectedRoute forAdmin>
            <UserDetailPage />
          </ProtectedRoute>
        ),
      },

      // notice
      {
        path: ROUTER_PATH.notice.dashboard._path,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <NoticeDashboardPage />
          </ProtectedRoute>
        ),
        handle: {
          title: "NOTICE",
        },
      },
      {
        path: ROUTER_PATH.notice.dashboard.detail(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <NoticeDashboardDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.notice.create,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <NoticeCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.notice.create,
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <NoticeCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.notice.dashboard.edit(),
        element: (
          <ProtectedRoute
            allowedRoles={[
              AUTHORITY_TYPES.대표이사,
              AUTHORITY_TYPES.정회원A,
              AUTHORITY_TYPES.정회원B,
              AUTHORITY_TYPES.정회원C,
            ]}
          >
            <NoticeDashboardEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTER_PATH.pushNotification._path,
        element: (
          <ProtectedRoute>
            <PushNotificationPage />
          </ProtectedRoute>
        ),
      },

      //etc
      { path: "*", element: <Page404 /> },
    ],
  },
  {
    path: ROUTER_PATH.preview.pdf,
    element: (
      <ProtectedRoute>
        <PdfPreviewPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/auth",
    element: (
      <Layout>
        <Outlet />
      </Layout>
    ),
    children: [
      //auth
      {
        path: ROUTER_PATH.auth.signIn,
        element: <AuthSignInPage />,
        handle: {
          title: "로그인",
        },
      },
      {
        path: ROUTER_PATH.auth.signUp,
        element: <AuthSignUpPage />,
        handle: {
          title: "회원가입",
        },
      },
      {
        path: ROUTER_PATH.auth.findPassword,
        element: <AuthFindPasswordPage />,
        handle: {
          title: "비밀번호 찾기",
        },
      },
    ],
  },
  {
    path: "/policy",
    children: [
      {
        path: ROUTER_PATH.policy.terms_of_service._path,
        element: (
          <Policy policyName={"이용약관"} policyType={"TERMS_OF_SERVICE"} />
        ),
      },
      {
        path: ROUTER_PATH.policy.privacy_policy._path,
        element: (
          <Policy
            policyName={"개인정보처리방침"}
            policyType={"PRIVACY_POLICY"}
          />
        ),
      },
    ],
  },
]);

export default routes;
